module.exports = __webpack_public_path__ + "static/media/bride-1.e2725d12.jpg";